import { render } from "./13Confirmation.vue?vue&type=template&id=b38a6bac"
import script from "./13Confirmation.vue?vue&type=script&lang=js"
export * from "./13Confirmation.vue?vue&type=script&lang=js"

import "./13Confirmation.vue?vue&type=style&index=0&id=b38a6bac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__